module.exports = __webpack_public_path__ + "media/images/logo-b606c8c8e68b2d7c6cab9647982f89a4.png";